import { render, staticRenderFns } from "./SeriesInfoTab.vue?vue&type=template&id=0f0b4d32&scoped=true"
import script from "./SeriesInfoTab.vue?vue&type=script&lang=js"
export * from "./SeriesInfoTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0b4d32",
  null
  
)

export default component.exports